export const TIME_RANGE = {
  SESSION: {
    value: 'SESSION'
  },
  WEEK: {
    value: 'WEEK'
  },
  MONTH: {
    value: 'MONTH'
  },
  CUSTOM: {
    value: 'CUSTOM'
  }
}

export const ENTITIES = {
  TEAM: 'TEAM',
  ALL_TEAMS: 'ALL_TEAMS',
  INDIVIDUAL: 'INDIVIDUAL'
}

export const METRICS = {
  TIME_ABOVE_80_PERCENT_HR: 'TIME_ABOVE_80_PERCENT_HR',
  AP_PERCENTAGE: 'AP_PERCENTAGE',
  DISTANCE: 'DISTANCE',
  WORKLOAD: 'WORKLOAD'
}

export const METRIC_COLOR = {
  TIME_ABOVE_80_PERCENT_HR: '#C93434',
  AP_PERCENTAGE: '#AF852A',
  AP: '#AF852A',
  DISTANCE: '#3C7E94',
  WORKLOAD: '#8D1DEF'
}